import { Controller } from "stimulus"

// Plays a muted, looping clip while it's on screen and pauses it when it
// scrolls away, so a post full of clips only plays the one being read, and a
// clip only downloads once it's reached. A clip the reader paused stays
// paused, and with reduced motion clips never start on their own (the
// controls still work). Markup comes from _includes/autoplay-video.html:
//
//   <video data-controller="autoplay-video" muted loop playsinline controls
//     preload="none" poster="..." src="..."></video>
export default class AutoplayVideoController extends Controller {

  connect() {
    this.element.muted = true
    this.pausedByReader = false
    this.pausingOffscreen = false
    this.onPause = () => {
      if (this.pausingOffscreen) this.pausingOffscreen = false
      else this.pausedByReader = true
    }
    this.onPlay = () => { this.pausedByReader = false }
    this.element.addEventListener('pause', this.onPause)
    this.element.addEventListener('play', this.onPlay)

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        if (!this.pausedByReader) this.element.play().catch(() => {})
      } else if (!this.element.paused) {
        // The pause event fires later, so flag it as ours rather than the reader's.
        this.pausingOffscreen = true
        this.element.pause()
      }
    }, { threshold: 0.5 })
    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
    this.element.removeEventListener('pause', this.onPause)
    this.element.removeEventListener('play', this.onPlay)
  }
}
